/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { getJsonExport } from '../helper/get-json-export.helper';
import { Locale } from '../model/locale.model';

import * as formats from '../format/core-en.format.json';
import * as texts from '../text/core-en.text.json';

export const coreEnLocale: Locale = {
  texts: getJsonExport(texts),
  formats: getJsonExport(formats)
};
